'use strict'

const { loginPageUrlFromParent } = require('../../shared/public-host')

const RESERVED_NAMES = new Set([
  'login',
  'www',
  'api',
  'mail',
  'admin',
  'accounts',
  'app',
  'apps',
  'static',
  'assets',
  'localhost'
])

const ACCOUNT_NAME_PATTERN = /^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/

function normalizeAccountName (value) {

  return String(value == null ? '' : value).trim().toLowerCase()
}

function accountNameError (value) {

  const name = normalizeAccountName(value)

  if (!name) {

    return 'choose an account name'
  }

  if (!ACCOUNT_NAME_PATTERN.test(name)) {

    return 'use at least 2 letters, numbers, or hyphens, and start and end with a letter or number'
  }

  if (RESERVED_NAMES.has(name)) {

    return 'that account name is reserved'
  }

  return ''
}

function slug (value) {

  return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9]/g, '')
}

function tenantLabel (account) {

  if (account && typeof account === 'object' && account.name) {

    return account.name
  }

  const id = account && typeof account === 'object' ? account._id : account

  return slug(id)
}

function parentDomain () {

  return process.env.TENANT_PARENT_DOMAIN || 'localhost'
}

function httpPort () {

  return process.env.TENANT_HTTP_PORT || '8080'
}

function isLocalParent (parent) {

  const domain = parent || parentDomain()

  return domain === 'localhost' || domain.endsWith('.localhost')
}

function tenantHostHeader (label, parent) {

  return `${label}.${parent || parentDomain()}`
}

function tenantHostname (label, parent, port) {

  const domain = parent || parentDomain()
  const header = tenantHostHeader(label, domain)

  if (isLocalParent(domain)) {

    return `${header}:${port || httpPort()}`
  }

  return header
}

function tenantBaseUrl (label, parent, port) {

  const domain = parent || parentDomain()
  const scheme = isLocalParent(domain) ? 'http' : 'https'

  return `${scheme}://${tenantHostname(label, domain, port)}`
}

function tenantAppsUrl (label, parent, port) {

  return `${tenantBaseUrl(label, parent, port)}/#/apps`
}

function loginUrl (parent, port) {

  if (process.env.TENANT_LOGIN_URL) {

    return process.env.TENANT_LOGIN_URL
  }

  return loginPageUrlFromParent(parent || parentDomain(), port || httpPort())
}

module.exports = {
  RESERVED_NAMES,
  normalizeAccountName,
  accountNameError,
  slug,
  tenantLabel,
  parentDomain,
  httpPort,
  isLocalParent,
  tenantHostHeader,
  tenantHostname,
  tenantBaseUrl,
  tenantAppsUrl,
  loginUrl
}
